const removeTags = text => {
  return text.replace(/<.+?>/g, "");
};

const removeSpecialChar = text => {
  return text.replace(/[^a-zA-Z ]/g, " ");
};

const truncate = (text, maxLength) => {
  let result = removeTags(text);
  if (result.length > maxLength) {
    result = result.substring(0, maxLength) + "...";
  }
  return result;
};

const divideTextUsingCapitalLetter = text => {
  if (text) {
    return text.replace(/([A-Z])/g, " $1").trim();
  }
};

const getFirstLetterOfEachWord = text => {
  return text.match(/\b(\w)/g).join("");
};

const formatPhoneNumber = text => {
  if (text) {
    var numbers = text.match(/\d/g);
    var i = 0,
      v = numbers.join("");
    var pattern = "(###) ###-####";
    return pattern.replace(/#/g, _ => v[i++]);
  }
};

const firstLetterToUpperCase = text => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const firstLetterOfEachWordToUpperCase = text => {
  return text
    .toLowerCase()
    .split(" ")
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
};

const toUpperCase = text => {
  return text.toUpperCase();
};

const formatConferenceType = type => {
  switch (type) {
    case "All":
      return null;
    case "Venue Based":
      return "VB";
    case "Cruise":
      return "CR";
    case "Courses":
      return "JO";
    case "Online":
      return "ON";
    default:
      return null;
  }
};

//it shortens huge numbers to something like 10k / 1M format
const abbrNum = (number, decPlaces) => {
  number = parseInt(number);
  decPlaces = Math.pow(10, decPlaces);
  const abbrev = ["k", "M", "b", "t"];

  for (let i = abbrev.length - 1; i >= 0; i--) {
    let size = Math.pow(10, (i + 1) * 3);
    if (size <= number) {
      number = Math.round(number * decPlaces / size) / decPlaces;
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }
      number += abbrev[i];
      break;
    }
  }
  return number;
};
const adjustLink = link => {
  if (link) {
    if ((link.startsWith("http") && link.includes("www")) || link.includes("/conferences/")) {
      return link;
    } else if (!link.includes("www") && !link.startsWith("http")) {
      return `https://www.${link}`;
    } else if (link.includes("www") && !link.includes("http")) {
      return `https://${link}`;
    } else if (!link.includes("www") && link.startsWith("https") && !link.includes("http:")) {
      const fixedLink = link.replace("https://", "https://www.");

      return fixedLink;
    } else if (!link.includes("www") && link.startsWith("http") && !link.includes("https")) {
      const fixedLink = link.replace("http://", "http://www.");
      return fixedLink;
    }
  }
};

export default {
  removeTags,
  truncate,
  formatPhoneNumber,
  divideTextUsingCapitalLetter,
  firstLetterToUpperCase,
  toUpperCase,
  removeSpecialChar,
  formatConferenceType,
  firstLetterOfEachWordToUpperCase,
  abbrNum,
  getFirstLetterOfEachWord,
  adjustLink
};



// WEBPACK FOOTER //
// ./src/components/login/utils/text-helper.js